module.exports = __webpack_public_path__ + "img/avatar3.40b0b055.png";